<template>
    <div class="login-form">
        <div class="login-form__title text_15 text_bold" v-if="showLabel">{{ $t("lk_auth") }}</div>
        <div class="login-form__type text_11">
            <div
                class="button button--text type__item"
                :class="{ active: activeLoginType == 'phone' }"
                @click="activeLoginType = 'phone'">
                {{ this.$i18n.t("login_type_phone") }}
            </div>
            <div
                class="button button--text type__item"
                :class="{ active: activeLoginType == 'email' }"
                @click="activeLoginType = 'email'">
                {{ this.$i18n.t("login_type_email") }}
            </div>
        </div>

        <LoginByEmail v-if="activeLoginType == 'email'" />
        <LoginByPhone v-if="activeLoginType == 'phone'" />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import LoginByEmail from "@/components/LoginByEmail.vue";
import LoginByPhone from "@/components/LoginByPhone.vue";
export default {
    components: { LoginByPhone, LoginByEmail },
    props: {
        showLabel: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            activeLoginType: "phone",
        };
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
    },
};
</script>
<style lang="less">
.login-form {
    padding-top: 40px;
    @media @sm {
        padding-top: 24px;
        padding-bottom: 24px;
    }
    .error {
        margin-top: 20px;
    }
}
.login-success {
    .text_15 {
        margin-bottom: 24px;
    }
}
.login-submit {
    margin-top: 24px;
    margin-bottom: 16px;
    height: 48px;
    .button {
        height: 48px;
    }
    .button--text {
        text-decoration: underline;
        padding: 0 60px;
        margin-left: 16px;
        text-underline-offset: 3px;
        text-decoration-skip: none;
        text-decoration-skip-ink: none;

        @media @sm {
            margin-left: 0;
            margin-top: 8px;
            width: 100%;
        }
    }
    @media @sm {
        height: auto;
        flex-direction: column;
        margin-top: 44px;
    }
}
.login-form__type {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 30px;
    @media @sm {
        justify-content: space-between;
    }
}
.type__item {
}
.type__item.active {
    border-bottom: 1px solid #000;
}
</style>
